import React from "react";
import "./courses.css";
import CoursesOverview from "./CoursesOverview";
import FeaturedCourses from "./FeaturedCourses";

const Courses = () => {
  return (
   <>
    <CoursesOverview />
    <FeaturedCourses />
   </>
  );
};

export default Courses;
